const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center px-1 pb-4 pt-3 lg:px-8">
      <p className="text-center text-sm text-ink-subtle">
        ©{new Date().getFullYear()} OmniSport. All Rights Reserved.
      </p>
    </div>
  );
};

export default Footer;
